import React from 'react';
import Navbar from '../components/Navbar';
import Cover from '../components/Cover';
import Mission from '../components/Mission';
import CardButton from '../components/CardButton';
import Projects from '../components/Projects';
import { Link } from 'react-router-dom';
import styles from '../styles/Home.module.css';

const Home: React.FC = () => {
  const scrollToTop = () => {
    window.scrollTo({ top: 0, behavior: 'smooth' });
  };
  return (
    <>
        <Navbar />
        <Cover imagePath='./first-cover2.png' textOnImage='Split Heritage'/>
        <Mission />
        <div className={styles.cardsContainer}>
          <Link to='/ourMission' className={styles.link} onClick={scrollToTop}><CardButton imagePath='./diocletians-palace.png' buttonText='OUR MISSION' /></Link>
          <Link to='contactUs' className={styles.link} onClick={scrollToTop}><CardButton imagePath='./split-night.png' buttonText='CONTACT US' /></Link>
        </div>
        <Projects />
    </>
  );
};

export default Home;